import { FaBars, FaUser, FaSignOutAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../http/authcontex";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./common.css";
import "./style.css";

export default function TopNav({ toggleSidebar }) {
  const authContext = useAuth();
  const { userEmail } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    authContext.logout();
    navigate("");
  };

  return (
    <div className="TopNav">
      <nav className="sb-topnav navbar navbar-expand navbar-light bg-light">
        <button
          className="btn btn-link btn-sm order-1 order-lg-0 me-3"
          id="sidebarToggle"
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
        >
          <FaBars />
        </button>

        <a className="navbar-brand ps-3 d-flex align-items-center" href="/">
          <img
            src="apitco_logo.png"
            alt="APITCO Logo"
            style={{ height: "50px", marginLeft: "10px" }}
          />
        </a>

        <ul className="navbar-nav ms-auto ms-md-50 me-3 me-lg-4">
          <li className="nav-item dropdown">
            <button
              className="nav-link dropdown-toggle"
              id="navbarDropdown"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <FaUser />
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="navbarDropdown"
            >
              {/* User Email */}
              <li>
                <div className="dropdown-item d-flex align-items-center">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flex: "none",
                    }}
                  >
                    <MdEmail className="small" />
                    <span>{userEmail || "Unknown"}</span>
                  </div>
                </div>
              </li>

              {/* Logout */}
              <li>
                <button
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleLogout}
                >
                  <FaSignOutAlt className="me-2" />
                  Logout
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  );
}
